export const resolveLabel = (code, list) => {
  if (!code || !Array.isArray(list)) return 'N/A';
  return list.find((i) => i.code === code)?.label || code;
};

/* ================= PRIMARY_CHAIN ================= */

export const PRIMARY_CHAIN_CODES = [
  {
    label: 'Primary Chain',
    tier: '179',
    class: '1791',
    inputType: 'select',
    options: [
      {
        code: '179101',
        category: 'Chain',
        subClass: 'Pecu-Novus',
        label: 'Pecu Novus'
      }
    ]
  }
];
/* ================= REDEMPTION ================= */

export const REDEMPTION_TYPE_CODES = [
  {
    label: 'Redemption',
    inputType: 'select',
    options: [
      {
        tier: '174',
        class: '1741',
        code: '174101',
        category: 'Redemption',
        subClass: 'Physical',
        label: 'Physical Redemption Eligible'
      },
      {
        tier: '174',
        class: '1741',
        code: '174102',
        category: 'Redemption',
        subClass: 'Cash',
        label: 'Cash Redemption'
      },
      {
        tier: '174',
        class: '1741',
        code: '174103',
        category: 'Redemption',
        subClass: 'In-Kind',
        label: 'In-Kind Reserve'
      },
      {
        tier: '174',
        class: '1741',
        code: '174104',
        category: 'Redemption',
        subClass: 'Digital',
        label: 'Digital Asset'
      },
      {
        tier: '174',
        class: '1741',
        code: '174105',
        category: 'Redemption',
        subClass: 'DAT-Reserve-Conversion',
        label: 'DAT Reserve Conversion'
      },
      {
        tier: '174',
        class: '1741',
        code: '174106',
        category: 'Redemption',
        subClass: 'DAT-Swap',
        label: 'DAT Swap'
      },
      {
        tier: '174',
        class: '1741',
        code: '174107',
        category: 'Redemption',
        subClass: 'Smart-Contract',
        label: 'Smart Contract Auto-Redemption'
      }
    ]
  }
];

/* ================= PROVENANCE ================= */

export const PROVENANCE_TYPE_CODES = [
  {
    label: 'Provenance',
    inputType: 'select',
    options: [
      {
        tier: '172',
        class: '1721',
        code: '172101',
        category: 'Provenance',
        subClass: 'Vault-Stored',
        label: 'Vault Stored Physical Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172102',
        category: 'Provenance',
        subClass: 'Government-Certified',
        label: 'Government Certified Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172103',
        category: 'Provenance',
        subClass: 'Pre-Mining',
        label: 'Geological Pre-Mining Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172104',
        category: 'Provenance',
        subClass: 'Pre-Drilled',
        label: 'Pre-Drilled Energy Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172105',
        category: 'Provenance',
        subClass: 'On-Chain',
        label: 'Onchain Digital Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172106',
        category: 'Provenance',
        subClass: 'Third-Party',
        label: 'Third-Party Custodied Reserves'
      },
      {
        tier: '172',
        class: '1721',
        code: '172107',
        category: 'Provenance',
        subClass: 'DAT-Verified',
        label: 'DAT-Verified Multi-Asset Reserves'
      }
    ]
  }
];

/* ================= COLLATERAL ================= */

export const COLLATERAL_TYPE_CODES = [
  {
    label: 'Collateral Architecture',
    inputType: 'select',
    options: [
      {
        tier: '171',
        class: '1711',
        code: '171101',
        category: 'Collateral Architecture',
        subClass: 'Single-Reserve',
        label: 'Single Reserve'
      },
      {
        tier: '171',
        class: '1711',
        code: '171102',
        category: 'Collateral Architecture',
        subClass: 'Multi-Reserve',
        label: 'Multi-Reserve'
      },
      {
        tier: '171',
        class: '1711',
        code: '171103',
        category: 'Collateral Architecture',
        subClass: 'Commodity-Only',
        label: 'Commodity Only'
      },
      {
        tier: '171',
        class: '1711',
        code: '171104',
        category: 'Collateral Architecture',
        subClass: 'Energy-Only',
        label: 'Energy Only'
      },
      {
        tier: '171',
        class: '1711',
        code: '171105',
        category: 'Collateral Architecture',
        subClass: 'Digital-Only',
        label: 'Digital Asset Only'
      },
      {
        tier: '171',
        class: '1711',
        code: '171106',
        category: 'Collateral Architecture',
        subClass: 'Hybrid Commodity+Digital',
        label: 'Hybrid Commodity + Digital'
      },
      {
        tier: '171',
        class: '1711',
        code: '171107',
        category: 'Collateral Architecture',
        subClass: 'Hybrid Energy+Digital',
        label: 'Hybrid Energy + Digital'
      },
      {
        tier: '171',
        class: '1711',
        code: '171108',
        category: 'Collateral Architecture',
        subClass: 'DAT-Managed',
        label: 'DAT Managed'
      },
      {
        tier: '171',
        class: '1711',
        code: '171109',
        category: 'Collateral Architecture',
        subClass: 'Smart-Contract',
        label: 'Smart Contract Managed'
      }
    ]
  }
];

/* ================= RISK ================= */

export const RISK_PROFILE_CODES = [
  {
    label: 'Risk Profile',
    inputType: 'select',
    options: [
      {
        tier: '175',
        class: '1751',
        code: '175101',
        category: 'Risk',
        subClass: 'Low-Volatility',
        label: 'Low Volatility Reserve Backed'
      },
      {
        tier: '175',
        class: '1751',
        code: '175102',
        category: 'Risk',
        subClass: 'Moderate-Risk',
        label: 'Moderate Risk Hybrid'
      },
      {
        tier: '175',
        class: '1751',
        code: '175103',
        category: 'Risk',
        subClass: 'High-Volatility',
        label: 'High-Volatility Digital-Backed'
      },
      {
        tier: '175',
        class: '1751',
        code: '175104',
        category: 'Risk',
        subClass: 'Commodity-Sensitive',
        label: 'Commodity-Price-Sensitive'
      },
      {
        tier: '175',
        class: '1751',
        code: '175105',
        category: 'Risk',
        subClass: 'Energy-Sensitive',
        label: 'Energy Reserve Sensitive'
      },
      {
        tier: '175',
        class: '1751',
        code: '175106',
        category: 'Risk',
        subClass: 'Balanced',
        label: 'Balanced Risk'
      },
      {
        tier: '175',
        class: '1751',
        code: '175107',
        category: 'Risk',
        subClass: 'Hedge',
        label: 'Hedge Oriented'
      }
    ]
  }
];

/* ================= RESERVE ================= */

export const RESERVE_TYPE_CODES = [
  {
    label: 'Reserve Type',
    inputType: 'multi-select',
    options: [
      {
        reserveTierCode: '170',
        reserveClassCode: '1701',
        reserveTypeCode: '170101',
        category: 'Precious Metals',
        subClass: 'Gold',
        label: 'Verified Gold Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1701',
        reserveTypeCode: '170102',
        category: 'Precious Metals',
        subClass: 'Silver',
        label: 'Verified Silver Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1701',
        reserveTypeCode: '170103',
        category: 'Precious Metals',
        subClass: 'Platinum',
        label: 'Verified Platinum Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1701',
        reserveTypeCode: '170104',
        category: 'Precious Metals',
        subClass: 'Palladium',
        label: 'Verified Palladium Reserve'
      },

      {
        reserveTierCode: '170',
        reserveClassCode: '1702',
        reserveTypeCode: '170201',
        category: 'Industrial Metals',
        subClass: 'Copper',
        label: 'Verified Copper Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1702',
        reserveTypeCode: '170202',
        category: 'Industrial Metals',
        subClass: 'Nickel',
        label: 'Verified Nickel Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1702',
        reserveTypeCode: '170203',
        category: 'Industrial Metals',
        subClass: 'Aluminum',
        label: 'Verified Aluminum Reserve'
      },

      {
        reserveTierCode: '170',
        reserveClassCode: '1703',
        reserveTypeCode: '170301',
        category: 'Energy Reserves',
        subClass: 'Oil',
        label: 'Verified Oil Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1703',
        reserveTypeCode: '170302',
        category: 'Energy Reserves',
        subClass: 'Pre-Drilled Oil',
        label: 'Verified Pre-Drilled Oil Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1703',
        reserveTypeCode: '170303',
        category: 'Energy Reserves',
        subClass: 'Natural Gas',
        label: 'Verified Natural Gas Reserve'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1703',
        reserveTypeCode: '170304',
        category: 'Energy Reserves',
        subClass: 'Pre-Drilled Gas',
        label: 'Verified Pre-Drilled Gas Reserve'
      },

      {
        reserveTierCode: '170',
        reserveClassCode: '1704',
        reserveTypeCode: '170401',
        category: 'Digital Asset Reserves',
        subClass: 'BTC',
        label: 'BTC Collateralized'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1704',
        reserveTypeCode: '170402',
        category: 'Digital Asset Reserves',
        subClass: 'ETH',
        label: 'ETH Collateralized'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1704',
        reserveTypeCode: '170403',
        category: 'Digital Asset Reserves',
        subClass: 'SOL',
        label: 'SOL Collateralized'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1704',
        reserveTypeCode: '170404',
        category: 'Digital Asset Reserves',
        subClass: 'PECU',
        label: 'PECU Collateralized'
      },
      {
        reserveTierCode: '170',
        reserveClassCode: '1704',
        reserveTypeCode: '170405',
        category: 'Digital Asset Reserves',
        subClass: 'Multi-Digital',
        label: 'Multi Digital Asset Treasury'
      }
    ]
  }
];

/* ================= TRANSPARENCY ================= */

export const TRANSPARENCY_TYPE_CODES = [
  {
    label: 'Transparency',
    inputType: 'select',
    options: [
      {
        tier: '176',
        class: '1761',
        code: '176101',
        category: 'Transparency',
        subClass: 'On-Chain',
        label: 'Full On-Chain Transparency'
      },
      {
        tier: '176',
        class: '1761',
        code: '176102',
        category: 'Transparency',
        subClass: 'Daily',
        label: 'Daily Reserve Reporting'
      },
      {
        tier: '176',
        class: '1761',
        code: '176103',
        category: 'Transparency',
        subClass: 'Monthly',
        label: 'Monthly Reserve Reporting'
      },
      {
        tier: '176',
        class: '1761',
        code: '176104',
        category: 'Transparency',
        subClass: 'Smart-Contract',
        label: 'Smart-Contract Verified Reserves'
      },
      {
        tier: '176',
        class: '1761',
        code: '176105',
        category: 'Transparency',
        subClass: 'Audited',
        label: 'Audited Reserve'
      },
      {
        tier: '176',
        class: '1761',
        code: '176106',
        category: 'Transparency',
        subClass: 'ZKP',
        label: 'Zero-Knowledge Proof Verified'
      }
    ]
  }
];

/* ================= VALUATION ================= */

export const VALUATION_TYPE_CODES = [
  {
    label: 'Valuation Method',
    inputType: 'select',
    options: [
      {
        tier: '173',
        class: '1731',
        code: '173101',
        category: 'Valuation',
        subClass: 'Spot-Pegged',
        label: 'Spot-Price Pegged'
      },
      {
        tier: '173',
        class: '1731',
        code: '173102',
        category: 'Valuation',
        subClass: 'NAV-Based',
        label: 'NAV-Based'
      },
      {
        tier: '173',
        class: '1731',
        code: '173103',
        category: 'Valuation',
        subClass: 'Oracle-Based',
        label: 'Oracle-Based Valuation'
      },
      {
        tier: '173',
        class: '1731',
        code: '173104',
        category: 'Valuation',
        subClass: 'Smart-Contract',
        label: 'Smart-Contract Verified Valuation'
      },
      {
        tier: '173',
        class: '1731',
        code: '173105',
        category: 'Valuation',
        subClass: 'Reserve-Weighted',
        label: 'Reserve-Weighted Valuation'
      },
      {
        tier: '173',
        class: '1731',
        code: '173106',
        category: 'Valuation',
        subClass: 'Forward-Curve',
        label: 'Forward-Curve Valuation'
      },
      {
        tier: '173',
        class: '1731',
        code: '173107',
        category: 'Valuation',
        subClass: 'Reserve-Adjusted',
        label: 'Reserve-Adjusted Valuation'
      }
    ]
  }
];

/* ================= TREASURY ================= */

export const TREASURY_MGMT_CODES = [
  {
    label: 'Treasury Type',
    inputType: 'select',
    options: [
      {
        tier: '177',
        class: '1771',
        code: '177101',
        category: 'Treasury',
        subClass: 'Issuer-Managed',
        label: 'Issuer-Managed Treasury'
      },
      {
        tier: '177',
        class: '1771',
        code: '177102',
        category: 'Treasury',
        subClass: 'DAT-Managed',
        label: 'DAT-Managed Treasury'
      },
      {
        tier: '177',
        class: '1771',
        code: '177103',
        category: 'Treasury',
        subClass: 'Smart-Contract',
        label: 'Smart-Contract Autonomous Treasury'
      },
      {
        tier: '177',
        class: '1771',
        code: '177104',
        category: 'Treasury',
        subClass: 'Hybrid',
        label: 'Hybrid Human + Smart-Contract Treasury'
      },
      {
        tier: '177',
        class: '1771',
        code: '177105',
        category: 'Treasury',
        subClass: 'Third-Party',
        label: 'Third-Party Custodied Treasury'
      }
    ]
  }
];
/* ================= EXPOSURE_MECHANISM ================= */

export const EXPOSURE_MECHANISM_CODES = [
  {
    label: 'Exposure Mechanism',
    tier: '178',
    class: '1781',
    inputType: 'select',
    options: [
      {
        code: '178101',
        category: 'Exposure',
        subClass: 'Spot-Pegged',
        label: 'Spot Pegged'
      },
      {
        code: '178102',
        category: 'Exposure',
        subClass: 'Index-Linked',
        label: 'Index Linked'
      },
      {
        code: '178103',
        category: 'Exposure',
        subClass: 'Basket-Linked',
        label: 'Basket Linked'
      },
      {
        code: '178104',
        category: 'Exposure',
        subClass: 'Oracle-Based',
        label: 'Oracle-Based'
      },
      {
        code: '178105',
        category: 'Exposure',
        subClass: 'NAV-Based',
        label: 'NAV-Based'
      },
      {
        code: '178106',
        category: 'Exposure',
        subClass: 'Reserve-Weighted',
        label: 'Reserve Weighted'
      },
      {
        code: '178107',
        category: 'Exposure',
        subClass: 'Smart-Contract',
        label: 'Smart Contract Formula'
      },
      {
        code: '178108',
        category: 'Exposure',
        subClass: 'Composite-Price-Pegged',
        label: 'Composite Price Pegged'
      }
    ]
  }
];
/* ================= UNDERLYING_ASSET_EXPOSURE ================= */

export const UNDERLYING_ASSET_EXPOSURE_CODES = [
  {
    label: 'Underlying Asset Exposure',
    tier: '178',
    class: '1782',
    inputType: 'select',
    options: [
      {
        code: '178201',
        category: 'Currency',
        subClass: 'AED',
        label: 'UAE Dirham'
      },
      {
        code: '178202',
        category: 'Currency',
        subClass: 'AFN',
        label: 'Afghani'
      },
      { code: '178203', category: 'Currency', subClass: 'ALL', label: 'Lek' },
      {
        code: '178204',
        category: 'Currency',
        subClass: 'AMD',
        label: 'Armenian Dram'
      },
      {
        code: '178205',
        category: 'Currency',
        subClass: 'ANG',
        label: 'Netherlands Antillean Guilder'
      },
      {
        code: '178206',
        category: 'Currency',
        subClass: 'AOA',
        label: 'Kwanza'
      },
      {
        code: '178207',
        category: 'Currency',
        subClass: 'ARS',
        label: 'Argentine Peso'
      },
      {
        code: '178208',
        category: 'Currency',
        subClass: 'AUD',
        label: 'Australian Dollar'
      },
      {
        code: '178209',
        category: 'Currency',
        subClass: 'AWG',
        label: 'Aruban Florin'
      },
      {
        code: '178210',
        category: 'Currency',
        subClass: 'AZN',
        label: 'Azerbaijan Manat'
      },
      {
        code: '178211',
        category: 'Currency',
        subClass: 'BAM',
        label: 'Convertible Mark'
      },
      {
        code: '178212',
        category: 'Currency',
        subClass: 'BBD',
        label: 'Barbados Dollar'
      },
      { code: '178213', category: 'Currency', subClass: 'BDT', label: 'Taka' },
      {
        code: '178214',
        category: 'Currency',
        subClass: 'BGN',
        label: 'Bulgarian Lev'
      },
      {
        code: '178215',
        category: 'Currency',
        subClass: 'BHD',
        label: 'Bahraini Dinar'
      },
      {
        code: '178216',
        category: 'Currency',
        subClass: 'BIF',
        label: 'Burundi Franc'
      },
      {
        code: '178217',
        category: 'Currency',
        subClass: 'BMD',
        label: 'Bermudian Dollar'
      },
      {
        code: '178218',
        category: 'Currency',
        subClass: 'BND',
        label: 'Brunei Dollar'
      },
      {
        code: '178219',
        category: 'Currency',
        subClass: 'BOB',
        label: 'Boliviano'
      },
      {
        code: '178220',
        category: 'Currency',
        subClass: 'BRL',
        label: 'Brazilian Real'
      },
      {
        code: '178221',
        category: 'Currency',
        subClass: 'BSD',
        label: 'Bahamian Dollar'
      },
      {
        code: '178222',
        category: 'Currency',
        subClass: 'BTN',
        label: 'Ngultrum'
      },
      { code: '178223', category: 'Currency', subClass: 'BWP', label: 'Pula' },
      {
        code: '178224',
        category: 'Currency',
        subClass: 'BYN',
        label: 'Belarusian Ruble'
      },
      {
        code: '178225',
        category: 'Currency',
        subClass: 'BZD',
        label: 'Belize Dollar'
      },
      {
        code: '178226',
        category: 'Currency',
        subClass: 'CAD',
        label: 'Canadian Dollar'
      },
      {
        code: '178227',
        category: 'Currency',
        subClass: 'CDF',
        label: 'Congolese Franc'
      },
      {
        code: '178228',
        category: 'Currency',
        subClass: 'CHF',
        label: 'Swiss Franc'
      },
      {
        code: '178229',
        category: 'Currency',
        subClass: 'CLP',
        label: 'Chilean Peso'
      },
      {
        code: '178230',
        category: 'Currency',
        subClass: 'CNY',
        label: 'Yuan Renminbi'
      },
      {
        code: '178231',
        category: 'Currency',
        subClass: 'COP',
        label: 'Colombian Peso'
      },
      {
        code: '178232',
        category: 'Currency',
        subClass: 'CRC',
        label: 'Costa Rican Colon'
      },
      {
        code: '178233',
        category: 'Currency',
        subClass: 'CUP',
        label: 'Cuban Peso'
      },
      {
        code: '178234',
        category: 'Currency',
        subClass: 'CVE',
        label: 'Cabo Verde Escudo'
      },
      {
        code: '178235',
        category: 'Currency',
        subClass: 'CZK',
        label: 'Czech Koruna'
      },
      {
        code: '178236',
        category: 'Currency',
        subClass: 'DJF',
        label: 'Djibouti Franc'
      },
      {
        code: '178237',
        category: 'Currency',
        subClass: 'DKK',
        label: 'Danish Krone'
      },
      {
        code: '178238',
        category: 'Currency',
        subClass: 'DOP',
        label: 'Dominican Peso'
      },
      {
        code: '178239',
        category: 'Currency',
        subClass: 'DZD',
        label: 'Algerian Dinar'
      },
      {
        code: '178240',
        category: 'Currency',
        subClass: 'EGP',
        label: 'Egyptian Pound'
      },
      { code: '178241', category: 'Currency', subClass: 'ERN', label: 'Nakfa' },
      {
        code: '178242',
        category: 'Currency',
        subClass: 'ETB',
        label: 'Ethiopian Birr'
      },
      { code: '178243', category: 'Currency', subClass: 'EUR', label: 'Euro' },
      {
        code: '178244',
        category: 'Currency',
        subClass: 'FJD',
        label: 'Fiji Dollar'
      },
      {
        code: '178245',
        category: 'Currency',
        subClass: 'FKP',
        label: 'Falkland Islands Pound'
      },
      {
        code: '178246',
        category: 'Currency',
        subClass: 'GBP',
        label: 'Pound Sterling'
      },
      { code: '178247', category: 'Currency', subClass: 'GEL', label: 'Lari' },
      {
        code: '178248',
        category: 'Currency',
        subClass: 'GHS',
        label: 'Ghana Cedi'
      },
      {
        code: '178249',
        category: 'Currency',
        subClass: 'GIP',
        label: 'Gibraltar Pound'
      },
      {
        code: '178250',
        category: 'Currency',
        subClass: 'GMD',
        label: 'Dalasi'
      },
      {
        code: '178251',
        category: 'Currency',
        subClass: 'GNF',
        label: 'Guinea Franc'
      },
      {
        code: '178252',
        category: 'Currency',
        subClass: 'GTQ',
        label: 'Quetzal'
      },
      {
        code: '178253',
        category: 'Currency',
        subClass: 'GYD',
        label: 'Guyana Dollar'
      },
      {
        code: '178254',
        category: 'Currency',
        subClass: 'HKD',
        label: 'Hong Kong Dollar'
      },
      {
        code: '178255',
        category: 'Currency',
        subClass: 'HNL',
        label: 'Lempira'
      },
      {
        code: '178256',
        category: 'Currency',
        subClass: 'HTG',
        label: 'Gourde'
      },
      {
        code: '178257',
        category: 'Currency',
        subClass: 'HUF',
        label: 'Forint'
      },
      {
        code: '178258',
        category: 'Currency',
        subClass: 'IDR',
        label: 'Rupiah'
      },
      {
        code: '178259',
        category: 'Currency',
        subClass: 'ILS',
        label: 'New Israeli Sheqel'
      },
      {
        code: '178260',
        category: 'Currency',
        subClass: 'INR',
        label: 'Indian Rupee'
      },
      {
        code: '178261',
        category: 'Currency',
        subClass: 'IQD',
        label: 'Iraqi Dinar'
      },
      {
        code: '178262',
        category: 'Currency',
        subClass: 'IRR',
        label: 'Iranian Rial'
      },
      {
        code: '178263',
        category: 'Currency',
        subClass: 'ISK',
        label: 'Iceland Krona'
      },
      {
        code: '178264',
        category: 'Currency',
        subClass: 'JMD',
        label: 'Jamaican Dollar'
      },
      {
        code: '178265',
        category: 'Currency',
        subClass: 'JOD',
        label: 'Jordanian Dinar'
      },
      { code: '178266', category: 'Currency', subClass: 'JPY', label: 'Yen' },
      {
        code: '178267',
        category: 'Currency',
        subClass: 'KES',
        label: 'Kenyan Shilling'
      },
      { code: '178268', category: 'Currency', subClass: 'KGS', label: 'Som' },
      { code: '178269', category: 'Currency', subClass: 'KHR', label: 'Riel' },
      {
        code: '178270',
        category: 'Currency',
        subClass: 'KMF',
        label: 'Comorian Franc'
      },
      {
        code: '178271',
        category: 'Currency',
        subClass: 'KPW',
        label: 'North Korean Won'
      },
      { code: '178272', category: 'Currency', subClass: 'KRW', label: 'Won' },
      {
        code: '178273',
        category: 'Currency',
        subClass: 'KWD',
        label: 'Kuwaiti Dinar'
      },
      {
        code: '178274',
        category: 'Currency',
        subClass: 'KYD',
        label: 'Cayman Islands Dollar'
      },
      { code: '178275', category: 'Currency', subClass: 'KZT', label: 'Tenge' },
      {
        code: '178276',
        category: 'Currency',
        subClass: 'LAK',
        label: 'Lao Kip'
      },
      {
        code: '178277',
        category: 'Currency',
        subClass: 'LBP',
        label: 'Lebanese Pound'
      },
      {
        code: '178278',
        category: 'Currency',
        subClass: 'LKR',
        label: 'Sri Lanka Rupee'
      },
      {
        code: '178279',
        category: 'Currency',
        subClass: 'LRD',
        label: 'Liberian Dollar'
      },
      { code: '178280', category: 'Currency', subClass: 'LSL', label: 'Loti' },
      {
        code: '178281',
        category: 'Currency',
        subClass: 'LYD',
        label: 'Libyan Dinar'
      },
      {
        code: '178282',
        category: 'Currency',
        subClass: 'MAD',
        label: 'Moroccan Dirham'
      },
      {
        code: '178283',
        category: 'Currency',
        subClass: 'MDL',
        label: 'Moldovan Leu'
      },
      {
        code: '178284',
        category: 'Currency',
        subClass: 'MGA',
        label: 'Malagasy Ariary'
      },
      { code: '178285', category: 'Currency', subClass: 'MKD', label: 'Denar' },
      { code: '178286', category: 'Currency', subClass: 'MMK', label: 'Kyat' },
      {
        code: '178287',
        category: 'Currency',
        subClass: 'MNT',
        label: 'Tugrik'
      },
      {
        code: '178288',
        category: 'Currency',
        subClass: 'MOP',
        label: 'Pataca'
      },
      {
        code: '178289',
        category: 'Currency',
        subClass: 'MRU',
        label: 'Ouguiya'
      },
      {
        code: '178290',
        category: 'Currency',
        subClass: 'MUR',
        label: 'Mauritius Rupee'
      },
      {
        code: '178291',
        category: 'Currency',
        subClass: 'MVR',
        label: 'Rufiyaa'
      },
      {
        code: '178292',
        category: 'Currency',
        subClass: 'MWK',
        label: 'Malawi Kwacha'
      },
      {
        code: '178293',
        category: 'Currency',
        subClass: 'MXN',
        label: 'Mexican Peso'
      },
      {
        code: '178294',
        category: 'Currency',
        subClass: 'MYR',
        label: 'Malaysian Ringgit'
      },
      {
        code: '178295',
        category: 'Currency',
        subClass: 'MZN',
        label: 'Mozambique Metical'
      },
      {
        code: '178296',
        category: 'Currency',
        subClass: 'NAD',
        label: 'Namibia Dollar'
      },
      { code: '178297', category: 'Currency', subClass: 'NGN', label: 'Naira' },
      {
        code: '178298',
        category: 'Currency',
        subClass: 'NIO',
        label: 'Cordoba Oro'
      },
      {
        code: '178299',
        category: 'Currency',
        subClass: 'NOK',
        label: 'Norwegian Krone'
      },
      {
        code: '178300',
        category: 'Currency',
        subClass: 'NPR',
        label: 'Nepalese Rupee'
      },
      {
        code: '178301',
        category: 'Currency',
        subClass: 'NZD',
        label: 'New Zealand Dollar'
      },
      {
        code: '178302',
        category: 'Currency',
        subClass: 'OMR',
        label: 'Rial Omani'
      },
      {
        code: '178303',
        category: 'Currency',
        subClass: 'PAB',
        label: 'Balboa'
      },
      { code: '178304', category: 'Currency', subClass: 'PEN', label: 'Sol' },
      { code: '178305', category: 'Currency', subClass: 'PGK', label: 'Kina' },
      {
        code: '178306',
        category: 'Currency',
        subClass: 'PHP',
        label: 'Philippine Peso'
      },
      {
        code: '178307',
        category: 'Currency',
        subClass: 'PKR',
        label: 'Pakistan Rupee'
      },
      { code: '178308', category: 'Currency', subClass: 'PLN', label: 'Zloty' },
      {
        code: '178309',
        category: 'Currency',
        subClass: 'PYG',
        label: 'Guarani'
      },
      {
        code: '178310',
        category: 'Currency',
        subClass: 'QAR',
        label: 'Qatari Rial'
      },
      {
        code: '178311',
        category: 'Currency',
        subClass: 'RON',
        label: 'Romanian Leu'
      },
      {
        code: '178312',
        category: 'Currency',
        subClass: 'RSD',
        label: 'Serbian Dinar'
      },
      {
        code: '178313',
        category: 'Currency',
        subClass: 'RUB',
        label: 'Russian Ruble'
      },
      {
        code: '178314',
        category: 'Currency',
        subClass: 'RWF',
        label: 'Rwanda Franc'
      },
      {
        code: '178315',
        category: 'Currency',
        subClass: 'SAR',
        label: 'Saudi Riyal'
      },
      {
        code: '178316',
        category: 'Currency',
        subClass: 'SBD',
        label: 'Solomon Islands Dollar'
      },
      {
        code: '178317',
        category: 'Currency',
        subClass: 'SCR',
        label: 'Seychelles Rupee'
      },
      {
        code: '178318',
        category: 'Currency',
        subClass: 'SDG',
        label: 'Sudanese Pound'
      },
      {
        code: '178319',
        category: 'Currency',
        subClass: 'SEK',
        label: 'Swedish Krona'
      },
      {
        code: '178320',
        category: 'Currency',
        subClass: 'SGD',
        label: 'Singapore Dollar'
      },
      {
        code: '178321',
        category: 'Currency',
        subClass: 'SHP',
        label: 'Saint Helena Pound'
      },
      { code: '178322', category: 'Currency', subClass: 'SLE', label: 'Leone' },
      { code: '178323', category: 'Currency', subClass: 'SLL', label: 'Leone' },
      {
        code: '178324',
        category: 'Currency',
        subClass: 'SOS',
        label: 'Somali Shilling'
      },
      {
        code: '178325',
        category: 'Currency',
        subClass: 'SRD',
        label: 'Surinam Dollar'
      },
      {
        code: '178326',
        category: 'Currency',
        subClass: 'SYP',
        label: 'Syrian Pound'
      },
      { code: '178327', category: 'Currency', subClass: 'STN', label: 'Dobra' },
      {
        code: '178328',
        category: 'Currency',
        subClass: 'SVC',
        label: 'El Salvador Colon'
      },
      {
        code: '178329',
        category: 'Currency',
        subClass: 'SZL',
        label: 'Lilangeni'
      },
      { code: '178330', category: 'Currency', subClass: 'THB', label: 'Baht' },
      {
        code: '178331',
        category: 'Currency',
        subClass: 'TJS',
        label: 'Somoni'
      },
      {
        code: '178332',
        category: 'Currency',
        subClass: 'TND',
        label: 'Tunisian Dinar'
      },
      {
        code: '178333',
        category: 'Currency',
        subClass: 'TRY',
        label: 'Turkish Lira'
      },
      {
        code: '178334',
        category: 'Currency',
        subClass: 'TTD',
        label: 'Trinidad and Tobago Dollar'
      },
      {
        code: '178335',
        category: 'Currency',
        subClass: 'TWD',
        label: 'New Taiwan Dollar'
      },
      {
        code: '178336',
        category: 'Currency',
        subClass: 'TZS',
        label: 'Tanzanian Silling'
      },
      {
        code: '178337',
        category: 'Currency',
        subClass: 'UAH',
        label: 'Hryvnia'
      },
      {
        code: '178338',
        category: 'Currency',
        subClass: 'UGX',
        label: 'Uganda Shilling'
      },
      {
        code: '178339',
        category: 'Currency',
        subClass: 'USD',
        label: 'US Dollar'
      },
      {
        code: '178340',
        category: 'Currency',
        subClass: 'UYU',
        label: 'Peso Uruguayo'
      },
      {
        code: '178341',
        category: 'Currency',
        subClass: 'UZS',
        label: 'Uzbekistan Sum'
      },
      {
        code: '178342',
        category: 'Currency',
        subClass: 'VES',
        label: 'Bolivar Soberano'
      },
      { code: '178343', category: 'Currency', subClass: 'VND', label: 'Dong' },
      { code: '178344', category: 'Currency', subClass: 'VUV', label: 'Vatu' },
      { code: '178345', category: 'Currency', subClass: 'WST', label: 'Tala' },
      {
        code: '178346',
        category: 'Currency',
        subClass: 'XAF',
        label: 'CFA Franc BEAC'
      },
      {
        code: '178347',
        category: 'Currency',
        subClass: 'XCD',
        label: 'East Caribbean Dollar'
      },
      {
        code: '178348',
        category: 'Currency',
        subClass: 'XOF',
        label: 'CFA Franc BCEAO'
      },
      {
        code: '178349',
        category: 'Currency',
        subClass: 'XPF',
        label: 'CFP Franc'
      },
      {
        code: '178350',
        category: 'Currency',
        subClass: 'YER',
        label: 'Yemeni Rial'
      },
      { code: '178351', category: 'Currency', subClass: 'ZAR', label: 'Rand' },
      {
        code: '178352',
        category: 'Currency',
        subClass: 'ZMW',
        label: 'Zambian Kwacha'
      },
      {
        code: '178353',
        category: 'Currency',
        subClass: 'ZWL',
        label: 'Zimbabwe Dollar'
      },

      {
        code: '178354',
        category: 'Commodity',
        subClass: 'Gold',
        label: 'Spot Gold'
      },
      {
        code: '178355',
        category: 'Commodity',
        subClass: 'Silver',
        label: 'Spot Silver'
      },
      {
        code: '178356',
        category: 'Commodity',
        subClass: 'Platinum',
        label: 'Spot Platinum'
      },
      {
        code: '178357',
        category: 'Commodity',
        subClass: 'Palladium',
        label: 'Spot Palladium'
      },
      {
        code: '178358',
        category: 'Commodity',
        subClass: 'Copper',
        label: 'Spot Copper'
      },
      {
        code: '178359',
        category: 'Commodity',
        subClass: 'Nickel',
        label: 'Spot Nickel'
      },
      {
        code: '178360',
        category: 'Commodity',
        subClass: 'Aluminum',
        label: 'Spot Aluminum'
      },
      {
        code: '178361',
        category: 'Commodity',
        subClass: 'WTI-Crude-Oil',
        label: 'Spot WTI Crude'
      },
      {
        code: '178362',
        category: 'Commodity',
        subClass: 'Brent-Crude-Oil',
        label: 'Spot Brent Crude'
      },
      {
        code: '178363',
        category: 'Commodity',
        subClass: 'Natural-Gas',
        label: 'Natural Gas'
      },
      {
        code: '178364',
        category: 'Commodity',
        subClass: 'Gasoline',
        label: 'Gasoline'
      },
      {
        code: '178365',
        category: 'Commodity',
        subClass: 'Cocoa',
        label: 'Cocoa'
      },
      {
        code: '178366',
        category: 'Commodity',
        subClass: 'Wheat',
        label: 'Wheat'
      },
      {
        code: '178367',
        category: 'Commodity',
        subClass: 'Corn',
        label: 'Corn'
      },
      {
        code: '178368',
        category: 'Commodity',
        subClass: 'Soybeans',
        label: 'Soybeans'
      }
    ]
  }
];

/* ================= BRIDGED_CHAINS ================= */

export const BRIDGED_CHAINS_CODES = [
  {
    label: 'Bridged Chains',
    tier: '179',
    class: '1792',
    inputType: 'multi-select',
    options: [
      {
        code: '179201',
        category: 'Chain',
        subClass: 'Ethereum',
        label: 'Ethereum'
      },
      {
        code: '179202',
        category: 'Chain',
        subClass: 'Solana',
        label: 'Solana'
      },
      {
        code: '179203',
        category: 'Chain',
        subClass: 'Arbitrum',
        label: 'Arbitrum'
      },
      {
        code: '179204',
        category: 'Chain',
        subClass: 'Polygon',
        label: 'Polygon'
      },
      {
        code: '179205',
        category: 'Chain',
        subClass: 'BNB-Chain',
        label: 'BNB Chain'
      },
      {
        code: '179206',
        category: 'Chain',
        subClass: 'Avalanche',
        label: 'Avalanche'
      },
      { code: '179207', category: 'Chain', subClass: 'Base', label: 'Base' },
      {
        code: '179208',
        category: 'Chain',
        subClass: 'Optimism',
        label: 'Optimism'
      },
      {
        code: '179209',
        category: 'Chain',
        subClass: 'Cardano',
        label: 'Cardano'
      },
      { code: '179210', category: 'Chain', subClass: 'TON', label: 'TON' },
      {
        code: '179211',
        category: 'Chain',
        subClass: 'In Progress',
        label: 'In Progress'
      }
    ]
  }
];
/* ================= ISSUER ================= */

export const ISSUER_CODES = [
  {
    label: 'Issuer',
    tier: '180',
    class: '1801',
    inputType: 'text'
  }
];
/* ================= TREASURY_KEY ================= */

export const TREASURY_KEY_CODES = [
  {
    label: 'Treasury Key',
    tier: '180',
    class: '1802',
    inputType: 'text'
  }
];
/* ================= COLLATERALIZATION_TYPE ================= */

export const COLLATERALIZATION_TYPE_CODES = [
  {
    label: 'Collateralization Type',
    tier: '180',
    class: '1803',
    inputType: 'select',
    options: [
      {
        code: '180301',
        category: 'Collateralization',
        subClass: 'Fully',
        label: 'Fully Collateralized'
      },
      {
        code: '180302',
        category: 'Collateralization',
        subClass: 'Over',
        label: 'Over-Collateralized'
      },
      {
        code: '180303',
        category: 'Collateralization',
        subClass: 'Partial',
        label: 'Partially Collateralized'
      },
      {
        code: '180304',
        category: 'Collateralization',
        subClass: 'Dynamic',
        label: 'Dynamic Collateralization'
      },
      {
        code: '180305',
        category: 'Collateralization',
        subClass: 'Volatility-Responsive',
        label: 'Volatility Responsive'
      }
    ]
  }
];
